<script>
  import { fade } from 'svelte/transition';
  import Collapsible from './Collapsible.svelte';
  import Leaderboard from './RankingLeaderboard.svelte';
  import { categories, races, raceResultsStore as data, uniqueRiderList} from '../stores'; 

  let styles = "letter-spacing: 2px; background-color:#2368A2; color:#AAD4F6; border-bottom: 1px solid black;";

  let latestRaceId = Math.max.apply(Math, $races.map(function(o) { let rid = 0; if(o.completed){rid = o.id}; return rid; }));
  const noOfRacesToCalculatePoints = $races.length - 1;
  const totalRacesNo = $races.length;

  $uniqueRiderList = new Map;
  const allRiderData = JSON.parse(JSON.stringify($data));
	allRiderData.forEach((el) => {
		$uniqueRiderList.set(el.pn, el);
	});
  
  $uniqueRiderList.forEach(function(value) {
    value.races =  JSON.parse(JSON.stringify(allRiderData.filter(item => item.pn === value.pn)));
    delete value.ri;
    delete value.p;
    delete value.r;
    delete value.t;
    value.totalPoints = getRiderTotalPoints(value.races);
    value.totalTopRacePoints = getRiderTotalTop6RacePoints(value.races, noOfRacesToCalculatePoints);// only get the top 6 ranked race points
    value.previousRacePoints = getRiderPreviousTotalPoints(value.races);
  });

  function getRiderTotalPoints(races) {
    let totalPoints = 0;
    for (const race of races) {
      totalPoints = totalPoints + parseInt(race.p);
    }
    getRiderTotalTop6RacePoints(races, 6);
    return totalPoints;
  }

  function getRiderTotalTop6RacePoints(races, noOfRaces) {
    let top6Points = 0;
    races.sort(function(a , b) {
      return b.p - a.p;
    });

    //console.log(races.length);
    let racePointArray = [];
    if (races.length >= noOfRaces) {
      racePointArray = races.slice(0, noOfRaces); 
    } else {
      racePointArray = races;
    }
    //console.log(racePointArray);
    
    for (const race of racePointArray) {
      top6Points = top6Points + parseInt(race.p);
    }
    
    return top6Points;
  }

  function getRiderPreviousTotalPoints(riderRaces) {
    let totalPreviousRacePoints = riderRaces.filter(race => race.ri < latestRaceId).map(rider => rider.p++).reduce((total, points) => total + points, 0);
    return totalPreviousRacePoints;
  }


   let playerRankings = JSON.parse(JSON.stringify(Array.from($uniqueRiderList.values())));
   
</script>

<!---
<div class="card">
  <div class="card-body">
    <p class="card-text">Listed below are the riders of each category, ranked based on the combined points awarded from all the races they have competed in.</p>
  </div>
</div>
-->
<div in:fade="{{delay: 250, duration: 300}}" class="mx-0 px-0">
  <div class="card border-dark mx-auto mt-1 mb-3 text-start" style="width:90%;">
    <div class="card-header container-background">RANKINGS</div>
    <div class="card-body text-dark">
      <p class="card-text">Listed below are the riders of each category, ranked based on the combined points awarded from the top ranked {noOfRacesToCalculatePoints} races  they have competed in.</p>
    </div>
  </div>


<section>
  {#each $categories as {id, name, age_range}}
    <Collapsible headerText={ name } headerStyle={styles} strokeStyle="#AAD4F6">
      <div class="content px-0 py-0 m-0 border-dark">
       <!--<Leaderboard categoryId={ id } participants={$uniqueRiderList} />-->
       <Leaderboard categoryId={ id } participants={playerRankings} />
      </div>
    </Collapsible>
  {/each}

</section>
</div>
<style>
	section {
		width: 100%;
	}
	
	.content {
		background-color: #f4f4f4;
		padding: 0.5em;
	}
</style>